import { Component, Input, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { MainService } from '../core/services/main.service';
import { User } from '../core/models';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { NgClickOutsideDelayOutsideDirective } from 'ng-click-outside2';

@Component({
    selector: 'app-landing-navbar',
    standalone: true,
    imports: [RouterLink, TranslocoPipe, AsyncPipe, NgClickOutsideDelayOutsideDirective],
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
})
export class LandingNavbarComponent implements OnInit {
    @Input() page: 'landing' | 'horseradish' = 'landing';
    user$: Observable<User>;
    isProcessing$: Observable<boolean>;

    menuOpen = false;
    _deliverySolutionsOpen = false;

    constructor(
        public translate: TranslocoService,
        private router: Router,
        private mainService: MainService
    ) { }

    ngOnInit(): void {
        this.user$ = this.mainService.userLoaded$;
        this.isProcessing$ = this.mainService.isProcessing$;
    }

    get deliverySolutionsOpen() {
        return this._deliverySolutionsOpen;
    }

    set deliverySolutionsOpen(v) {
        this._deliverySolutionsOpen = v;
    }

    setLanguage(language: string) {
        this.router.navigateByUrl(this.router.url.replace(this.translate.getActiveLang(), language));
        this.mainService.setLanguage(language);
    }

    toggleMenu() {
        this.menuOpen = !this.menuOpen;
    }

    toggleDeliverySolutions() {
        this._deliverySolutionsOpen = !this._deliverySolutionsOpen;
    }
}
